// Action Types

export const Types = {
  GET_TI_SOLICITATIONS_REQUESTED: 'patrimony/GET_TI_SOLICITATIONS_REQUESTED',
  GET_TI_SOLICITATIONS_SUCCEEDED: 'patrimony/GET_TI_SOLICITATIONS_SUCCEEDED',
  GET_TI_SOLICITATIONS_FAILED: 'patrimony/GET_TI_SOLICITATIONS_FAILED',

  POST_TI_SOLICITATION_REQUESTED: 'patrimony/POST_TI_SOLICITATION_REQUESTED',
  POST_TI_SOLICITATION_SUCCEEDED: 'patrimony/POST_TI_SOLICITATION_SUCCEEDED',
  POST_TI_SOLICITATION_FAILED: 'patrimony/POST_TI_SOLICITATION_FAILED',

  GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_REQUESTED: 'patrimony/GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_REQUESTED',
  GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_SUCCEEDED: 'patrimony/GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_SUCCEEDED',
  GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_FAILED: 'patrimony/GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_FAILED',

  POST_PURCH_AND_MAINTENANCE_SOLICITATION_REQUESTED: 'patrimony/POST_PURCH_AND_MAINTENANCE_SOLICITATION_REQUESTED',
  POST_PURCH_AND_MAINTENANCE_SOLICITATION_SUCCEEDED: 'patrimony/POST_PURCH_AND_MAINTENANCE_SOLICITATION_SUCCEEDED',
  POST_PURCH_AND_MAINTENANCE_SOLICITATION_FAILED: 'patrimony/POST_PURCH_AND_MAINTENANCE_SOLICITATION_FAILED',
}

// Action Creators

export function getTiSolicitations() {
  return {
    type: Types.GET_TI_SOLICITATIONS_REQUESTED,
  }
}

export function postTiSolicitation(data) {
  return {
    type: Types.POST_TI_SOLICITATION_REQUESTED,
    payload: data,
  }
}

export function getPurchAndMaintenanceSolicitations() {
  return {
    type: Types.GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_REQUESTED,
  }
}

export function postPurchAndMaintenanceSolicitation(data) {
  return {
    type: Types.POST_PURCH_AND_MAINTENANCE_SOLICITATION_REQUESTED,
    payload: data,
  }
}

// Reducer

const INITIAL_STATE = {
  getTiSolicitationsIsLoading: false,
  getTiSolicitationsError: null,
  tiSolicitations: null,

  postTiSolicitationIsLoading: false,
  postTiSolicitationSuccess: null,
  postTiSolicitationError: null,

  getPurchAndMaintenanceSolicitationsIsLoading: false,
  getPurchAndMaintenanceSolicitationsError: null,
  purchAndMaintenanceSolicitations: null,

  postPurchAndMaintenanceSolicitationIsLoading: false,
  postPurchAndMaintenanceSolicitationSuccess: null,
  postPurchAndMaintenanceSolicitationError: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_TI_SOLICITATIONS_REQUESTED:
      return {
        ...state,
        getTiSolicitationsIsLoading: true,
      }
    case Types.GET_TI_SOLICITATIONS_SUCCEEDED:
      return {
        ...state,
        getTiSolicitationsIsLoading: false,
        getTiSolicitationsError: null,
        tiSolicitations: action.payload,
      }
    case Types.GET_TI_SOLICITATIONS_FAILED:
      return {
        ...state,
        getTiSolicitationsIsLoading: false,
        getTiSolicitationsError: action.payload,
        tiSolicitations: null,
      }

    case Types.POST_TI_SOLICITATION_REQUESTED:
      return {
        ...state,
        postTiSolicitationIsLoading: true,
        postTiSolicitationSuccess: false,
      }
    case Types.POST_TI_SOLICITATION_SUCCEEDED:
      return {
        ...state,
        postTiSolicitationIsLoading: false,
        postTiSolicitationError: null,
        postTiSolicitationSuccess: true,
      }
    case Types.POST_TI_SOLICITATION_FAILED:
      return {
        ...state,
        postTiSolicitationIsLoading: false,
        postTiSolicitationError: action.payload,
        postTiSolicitationSuccess: false,
      }

    case Types.GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_REQUESTED:
      return {
        ...state,
        getPurchAndMaintenanceSolicitationsIsLoading: true,
      }
    case Types.GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_SUCCEEDED:
      return {
        ...state,
        getPurchAndMaintenanceSolicitationsIsLoading: false,
        getPurchAndMaintenanceSolicitationsError: null,
        purchAndMaintenanceSolicitations: action.payload,
      }
    case Types.GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_FAILED:
      return {
        ...state,
        getPurchAndMaintenanceSolicitationsIsLoading: false,
        getPurchAndMaintenanceSolicitationsError: action.payload,
        purchAndMaintenanceSolicitations: null,
      }

    case Types.POST_PURCH_AND_MAINTENANCE_SOLICITATION_REQUESTED:
      return {
        ...state,
        postPurchAndMaintenanceSolicitationIsLoading: true,
        postPurchAndMaintenanceSolicitationSuccess: false,
      }
    case Types.POST_PURCH_AND_MAINTENANCE_SOLICITATION_SUCCEEDED:
      return {
        ...state,
        postPurchAndMaintenanceSolicitationIsLoading: false,
        postPurchAndMaintenanceSolicitationError: null,
        postPurchAndMaintenanceSolicitationSuccess: true,
      }
    case Types.POST_PURCH_AND_MAINTENANCE_SOLICITATION_FAILED:
      return {
        ...state,
        postPurchAndMaintenanceSolicitationIsLoading: false,
        postPurchAndMaintenanceSolicitationError: action.payload,
        postPurchAndMaintenanceSolicitationSuccess: false,
      }

    default:
      return state
  }
}
